import React from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import "./Blogs.css"; // reuse variables & base look if you like

export default function BlogDetail() {
  const { slug } = useParams();
  const location = useLocation();
  const post = location.state?.post;

  return (
    <article className="blogs-wrap" style={{ maxWidth: 900 }}>
      <Link to="/blogs" className="card-tag" style={{ textDecoration: "none" }}>
        ← Back to Blogs
      </Link>

      <header style={{ marginTop: 12, marginBottom: 14 }}>
        <p className="blogs-kicker">BLOG</p>
        <h1 className="blogs-title" style={{ fontSize: "clamp(28px,4.5vw,44px)" }}>
          {post?.title || slug}
        </h1>
        {post?.date && (
          <p className="blogs-sub" style={{ marginTop: 4 }}>
            {post.date} • {post.readTime}
          </p>
        )}
      </header>

      {post?.image && (
        <div
          style={{
            borderRadius: 18,
            overflow: "hidden",
            border: "1px solid rgba(2,6,23,0.08)",
            boxShadow: "0 18px 46px rgba(2,6,23,.12)",
          }}
        >
          <img
            src={post.image}
            alt={post.title}
            style={{ width: "100%", height: "auto", display: "block" }}
            loading="lazy"
          />
        </div>
      )}

      <div style={{ marginTop: 18, color: "#1f2937", fontSize: 16, lineHeight: 1.7 }}>
        <p>
          {post?.excerpt ||
            "This is a sample blog detail. If you navigated directly via URL, pass content by fetching with the slug."}
        </p>
        <p>
          You can replace this with your CMS content — just fetch by <strong>slug</strong> and render here.
        </p>
      </div>

      {post?.tags?.length ? (
        <div className="card-tags" style={{ marginTop: 16 }}>
          {post.tags.map((t) => (
            <span key={t} className="card-tag">
              {t}
            </span>
          ))}
        </div>
      ) : null}
    </article>
  );
}
